import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {ErrorText, FindLoad, FindSuccessItem, useModal} from 'utils';
import {claimActions} from 'store';
import {CreateChancel, UserTextArea} from 'components';

export const RejectClaim = ({ids, single, afterSuccess, status}) => {
    const ACTION_TYPE = 'CHANGE_CLAIM_STATUS';
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const dispatch = useDispatch();
    const {close} = useModal();
    const [comment, setComment] = React.useState('');
    const [error, setError] = React.useState('');

    useEffect(() => {
        if (success) {
            close();
            if (afterSuccess) {
                afterSuccess();
            }
        }
    }, [success]);

    const handleSubmit = () => {
        dispatch(
            claimActions.changeClaimStatus({
                    claimIds: ids,
                    clearinghouseStatus: status,
                    clearinghouseReason: comment ? comment : '',
                },
                single
            )
        );
    };

    return (
        <div style={{width: 400}}>
            <div>
                <p className='modal-header-title'>{'Rejection Reason'}</p>
                <div style={{marginTop: 24}}>
                    <UserTextArea
                        margin={'0'}
                        id={'clearinghouseReason'}
                        name={'clearinghouseReason'}
                        label={`Rejection Reason`}
                        value={comment ? comment : ' '}
                        onChange={(e) => {
                            setComment(e.target.value);
                            error && setError('');
                        }}
                        max={100}
                        hasText={!!comment}
                        maxCharsLabel={`${comment?.length || 0}/100`}
                        typeError={error === 'clearinghouseReason' && `Comment ${ErrorText.isRequired}`}
                        placeholder={'Enter additional reason'}
                    />
                </div>

                <CreateChancel
                    loader={!!loader?.length}
                    create={'Save'}
                    chancel={'Cancel'}
                    onCreate={handleSubmit}
                    onClose={() => close()}
                    buttonWidth="100%"
                />
            </div>
        </div>
    );
};
